import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency, formatDate } from '../../../lib/utils';
import { ApplicationStatuses, CurrencyTypes } from '../../../lib/systemVariables';
import { TableViews } from '../../../lib/constants';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import ApplicationStatusTag from '../../commonComponents/shared/ApplicationStatusTag';
import UpdateApplicationAmtInput from '../../commonComponents/shared/UpdateApplicationAmtInput';
import RecipientSummaryCard from './RecipientSummaryCard';

export default class ApplicationsTableRow extends NavigationComponent {

    state = { summaryOpen: false };

    // getCombinedNotes = (applicationNote, recipientNote) => {
    //     if (!applicationNote && !recipientNote) return;

    //     const limit = 50;

    //     if (applicationNote && recipientNote) {
    //         let applicationNoteTrimmed = applicationNote;
    //         let recipientNoteTrimmed = recipientNote;

    //         if ((applicationNote.length + recipientNote.length) > limit) {
    //             if (applicationNote.length > (limit / 2) && recipientNote.length > (limit / 2)) {
    //                 applicationNoteTrimmed = applicationNote.substring(0, (limit / 2));
    //                 recipientNoteTrimmed = recipientNote.substring(0, (limit / 2));
    //             } else if (recipientNote.length > (limit / 2)) {
    //                 recipientNoteTrimmed = recipientNote.substring(0, (limit - applicationNote));
    //             } else if (applicationNote.length > (limit / 2)) {
    //                 applicationNoteTrimmed = applicationNote.substring(0, (limit - recipientNote));
    //             }
    //         }

    //         return `Application Notes: ${applicationNoteTrimmed} | Recipient Notes: ${recipientNoteTrimmed}`
    //     }

    //     return applicationNote
    //         ? `Application Notes: ${applicationNote.substring(0, limit)}`
    //         : `Recipient Notes: ${recipientNote.substring(0, limit)}`;
    // // }

    // getNoteDisplay = note => {
    //     const limit = 50;
    //     return (note && note.length > limit) ? note.substring(0, limit) + "..." : note;
    // }

    render() {
        const { applicationId, status, recipient = {}, sourceName, applicationDate, amount, fundName, campaign = {}, reason, hasAttachments, hasReceipt, isBlocked, isPrivate, inquire, currency, note, printedUnconfirmed, canBeDeleted } = this.props.application;

        const { status: tableStatus, permissions, view } = this.props;
        const canApprove = permissions.approveFull || permissions.approveLimited;
        const canManage = permissions.manage;
        const canPrintOrWire = this.props.isUSUser ? permissions.print : permissions.wire;
        const fund = this.props.fund;

        let disabledTooltip = '';

        if(isBlocked) {
            disabledTooltip = 'You do not have access to this application'
        } else if ((status === ApplicationStatuses.New || status === ApplicationStatuses.Approved) && !amount)
            disabledTooltip = 'Application amount required'
        else if ((status === ApplicationStatuses.New || status === ApplicationStatuses.Approved) && !fund)
            disabledTooltip = 'Fund data unavailable'
        else if (status === ApplicationStatuses.New && currency === CurrencyTypes.Dollar && !permissions.approveFull && amount > fund.limitedApprovalMax)
            disabledTooltip = 'Application amount exceeds your approval max';
        else if (status === ApplicationStatuses.Approved && amount > (currency === CurrencyTypes.Shekel ? fund.wiringMax : fund.checkCuttingMax))
            disabledTooltip = `Application amount exceeds ${currency === CurrencyTypes.Shekel ? 'wiring' : 'check cutting'} max`;
        else if (status === ApplicationStatuses.Approved && printedUnconfirmed) {
            disabledTooltip = 'Application requires printing confirmation';
        }
        
        return (
            <HoverTableRow
                className={`table-row ${view === TableViews.Detailed ? 'application-row-detailed' : ''} ${this.state.summaryOpen ? 'recipient-summary-open' : ''}`}
                onClick={this.pushRouteWithProps.bind(this,
                    `/recipient-accounts/${recipient.recipientId}?applicationId=${applicationId}`, {
                        prevPage: `${tableStatus ? `${ApplicationStatuses[tableStatus]} ` : ''}Applications`,
                        applicationId
                    })}>
                {((tableStatus === ApplicationStatuses.New && canApprove) || (tableStatus === ApplicationStatuses.Approved && canPrintOrWire)) &&
                    <td data-label="Select">
                        <div className={`custom-check-container name-check-container ${disabledTooltip ? "disabled" : ""}`}>
                            <input type="checkbox" id={`name-${applicationId}`} className="custom-check input"
                                checked={this.props.selected} onChange={() => this.props.selectApplication(this.props.application)}
                                disabled={disabledTooltip} />
                            <label htmlFor={`name-${applicationId}`} className="secondary-text input"
                                title={disabledTooltip} />
                        </div>
                    </td>}
                <td>
                    {recipient.firstName && <p className="small-text">{recipient.firstName}</p>}
                </td>
                <td data-label="Name" className="application-name">
                    <div className="application-name-row">
                        <p className="bold-text application-name-text">
                            <Link to={`/recipient-accounts/${recipient.recipientId}?applicationId=${applicationId}`}>
                                {recipient.lastOrOrgName}
                            </Link>
                        </p>
                        {inquire &&
                            <span className="tag inquire">Inquire</span>}
                        <RecipientSummaryCard recipientId={recipient.recipientId} disabled={isBlocked}
                            onOpenChange={summaryOpen => this.setState({ summaryOpen })}
                            title={`${recipient.firstName ? `${recipient.firstName} ` : ''}${recipient.lastOrOrgName || ''}`.trim()} />
                    </div>
                </td>

                {view === TableViews.Detailed &&
                    <td>
                        {recipient.addressDisplay && <p className="small-text"><i className="icon-location-pin icon-left accent-text2"></i>{recipient.addressDisplay}</p>}
                    </td>}
                {view === TableViews.Detailed &&
                    <td>
                        {recipient.teudatZahut && <p className="small-text"><i className="icon-doc icon-left accent-text2"></i>{recipient.teudatZahut}</p>}
                    </td>}
                {view === TableViews.Detailed &&
                    <td className="text-right">
                        {recipient.totalPaid && <p className="small-text"><i className="icon-wallet icon-left accent-text2"></i>{recipient.totalPaid}</p>}
                    </td>}
                <td data-label="Application Date">{formatDate(applicationDate)}</td>
                <td data-label="Details">
                    {campaign.name ?
                        <div>
                            <span className="accent-text2">{campaign.name}</span>
                            <p>{campaign.campaignListName}</p>
                        </div> :
                        <span>{reason}</span>
                    }
                    {hasAttachments && <i className="material-icons debt-attach accent-text middle">attach_file</i>}
                    {hasReceipt && <i className="icon-doc accent-text middle" style={{ marginLeft: '4px' }} title="Has Receipt" />}
                </td>
                <td data-label="Status">
                    <ApplicationStatusTag status={status} />
                </td>
                <td data-label="Amount" className="text-right">
                    {(tableStatus === ApplicationStatuses.New && canApprove && canManage && !isBlocked) 
                        ? <UpdateApplicationAmtInput 
                            application={this.props.application}
                            updateError={this.props.updateError}
                            update={this.props.update}
                            maxAmount={this.props.application.maxApprovalAmount}/> 
                        : <p>{formatCurrency(amount, currency === CurrencyTypes.Shekel)}</p>}
                </td>
                {view === TableViews.Detailed
                    ? <td data-label="Source">
                        <p>{sourceName}</p>
                    </td>
                    : <td data-label="Fund">
                        <p>{fundName}</p>
                    </td>}
                {view === TableViews.Detailed
                    && <td data-label="Note">{note}</td>}
                {view === TableViews.Detailed
                    && <td data-label="References">{recipient.references ? `${recipient.references.substring(0, 50)}${recipient.references.length > 50 ? '...' : ''}` : ''}</td>}
                <td data-label="IsPrivate">
                    <div className="flex">
                        {(isPrivate) && <p className="private-icon mr-8">
                            <i className="material-icons accent-text">lock_outline</i>
                            <span className="tooltip private-tooltip">Private</span>
                        </p>}
                        {(isBlocked) && <p className="private-icon">
                            <i className="material-icons accent-text">visibility_off_outline</i>
                            <span className="tooltip private-tooltip">Private</span>
                        </p>}
                    </div>
                </td>
                 <td data-label="IsAchEnabled">
                  {(recipient.hasAchAccount) && (
                        <p>
                            <i className="material-icons accent-text">check_circle</i>
                            <span className="tooltip private-tooltip">ACH Enabled</span>
                        </p>
                  )}

                </td>
                {
                    canManage && !isBlocked && (!tableStatus || tableStatus === ApplicationStatuses.New || tableStatus === ApplicationStatuses.Incomplete)
                    ? <td data-label="Delete">
                        {canBeDeleted && <i className="icon-trash trash-hover input" onClick={this.props.delete}></i>}
                    </td> : <td />
                }
            </HoverTableRow >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applications/ApplicationsTableRow.jsx